<template>
    <div class="donate" id="donate">
        <div class="container">
            <div class="row">
                <!-- Section Header -->
                <div class="section-header">
                    <h2 class="section-title">Поддержать</h2>
                    <h3 class="section-subtitle">
                        А мы вам за это инвайт, когда состоится релиз. <br>
                        Бета-тестовый вход, скидки и всякие плюшки когда запустимся.

                    </h3>
                </div>
                <!-- End Section Header -->
                <div class="col-xs-12 donate-content animateblock btt speed-1">
                <div class="col-md-6 box">
                    <img src="landing/static/images/donate_img_1.png" alt="">

                </div>
                <div class="col-md-6 box">
                    <img src="landing/static/images/donate_img_2.png" alt="">
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Donate",
        data() {
            return {
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Donate.vue?eee07964